import { TaskRegistry, InputStep, Context } from '@things-factory/integration-base'
import { getDataSource } from '@things-factory/shell'
import { access } from '@things-factory/utils'
import i18next from 'i18next'

import { DataSet } from '../../service/data-set/data-set.js'
import { createDataSample } from '../../controllers/create-data-sample.js'

async function CreateDataSample(step: InputStep, context: Context) {
  const { data, domain, user, lng } = context
  var {
    params: {
      dataset: dataSetId,
      source: sourceAccessor,
      rawData: rawDataAccessor,
      data: dataAccessor,
      timestamp: timestampAccessor
    }
  } = step

  if (!dataSetId) {
    throw new Error(`no dataset found`)
  }

  // make new data-sample
  return await getDataSource().transaction(async tx => {
    const dataSet = await tx.getRepository(DataSet).findOne({
      where: {
        id: dataSetId
      }
    })

    var source = await access(sourceAccessor, data)
    var extractedData = await access(dataAccessor, data)
    var extractedRawData = rawDataAccessor && (await access(rawDataAccessor, data))
    var timestamp = timestampAccessor && (await access(timestampAccessor, data))

    const dataSample = await createDataSample(
      {
        dataSet,
        data: extractedData,
        rawData: extractedRawData,
        source,
        collectedAt: new Date(timestamp || new Date())
      },
      {
        t: i18next.t,
        state: {
          domain,
          user,
          lng,
          tx
        }
      }
    )

    return {
      data: dataSample
    }
  })
}

CreateDataSample.parameterSpec = [
  {
    type: 'entity-selector',
    name: 'dataset',
    label: 'data-set',
    property: {
      queryName: 'dataSets',
      valueKey: 'id'
    }
  },
  {
    type: 'string',
    name: 'source',
    label: 'source'
  },
  {
    type: 'string',
    name: 'rawData',
    label: 'raw-data'
  },
  {
    type: 'string',
    name: 'data',
    label: 'data'
  },
  {
    type: 'string',
    name: 'timestamp',
    label: 'timestamp'
  }
]

CreateDataSample.connectorFree = true
CreateDataSample.help = 'dataset/task/create-data-sample'

TaskRegistry.registerTaskHandler('create-data-sample', CreateDataSample)
